export const DealerPositionName = {
  OWNER: 'Owner',
  MANAGING_DIRECTOR: 'Managing Director',
  OPERATIONS_DIRECTOR: 'Operations Director',
  DEALER_PRINCIPLE: 'Dealer Principle',
  HEAD_OF_BUSINESS: 'Head Of Business',
  GENERAL_MANAGER: 'General Manager',
  SALES_MANAGER: 'Sales Manager',
  SALES_CONTROLLER: 'Sales Controller',
  SALES_EXECUTIVE: 'Sales Executive',
  TRADE_DISPOSALS: 'Trade Disposals',
  GROUP_BUYER: 'Group Buyer',
  BUYER: 'Buyer',
};
